import { useFunction } from "@aec-craft/nb-generative";
import { useSnackbarStore } from "@fe/snackbar/snackbar.store";

export const useAsyncFunction = <
	T extends (...args: Parameters<T>) => ReturnType<T>,
>(
	callback: T,
	errorMessage: string | ((error: unknown) => string) = "An error occurred",
) => {
	const { addMessage } = useSnackbarStore.getState();

	return useFunction(async (...args: Parameters<T>) => {
		try {
			return await callback(...args);
		} catch (error) {
			if (typeof errorMessage === "string") {
				addMessage(errorMessage);
			} else {
				addMessage(errorMessage(error));
			}
		}
	});
};
